import { useEffect, useRef, useState } from 'react';
import { H3, H4 } from '../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../styles/FontStyles';
import { color } from '../../styles/GlobalStyles';
import {
  Icon,
  IconPortfolioOrders,
  IconPortfolioPoolTicket,
  IconTravelPackages
} from '../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from './Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import { formatUSD } from '../../helpers/helperFunctions';
import { getMyHubsTravel } from './Portfolio.actions';
import { TRAVEL_PACKAGES } from '../../routes/routes';
import Spinner from '../../components/common/Spinner';
import { PortfolioTravelItem } from './PortfolioTravelItem';

export const TravelSummary = () => {
  const dispatch = useDispatch();

  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { travelPackages, loadingSummary } = useAppSelector(
    (state) => state.portfolio
  );

  useEffect(() => {
    dispatch(getMyHubsTravel());
  }, [dispatch]);

  return (
    <div style={{ marginBottom: 40 }}>
      <Flexed mb='20' center between>
        <H3>My Travelution Membership Summary</H3>
      </Flexed>

      <SummaryGrid columns>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total Travelution Orders
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(travelPackages?.summary?.totalOrderAmount)}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <SummaryGrid columns>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Silver pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.silverPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.silverPoolTickets === 1
                  ? 'Ticket'
                  : 'Tickets'}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Gold Pool Ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.goldPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.goldPoolTickets === 1
                  ? 'Ticket'
                  : 'Tickets'}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Platinum pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.platinumPoolTickets}
              <P3 mb='1'>
                {travelPackages?.summary?.platinumPoolTickets === 1
                  ? 'Ticket'
                  : 'Tickets'}{' '}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioPoolTicket />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Ultra-VIP pool ticket
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {travelPackages?.summary?.ultraVipPoolTickets}
              <P3 mb='1'>
                {' '}
                {travelPackages?.summary?.ultraVipPoolTickets === 1
                  ? 'Ticket'
                  : 'Tickets'}{' '}
              </P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <div style={{ position: 'relative' }}>
        {loadingSummary && <Spinner absolute transparent />}
      </div>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>My Travelution Memberships</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>

        <Button
          negative
          maxWidth='350px'
          maxWidthSM='100%'
          onClick={() => history.push(TRAVEL_PACKAGES)}>
          ADD TRAVELUTION MEMBERSHIP
        </Button>
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {travelPackages?.userPackages?.map((item: any, i: number) => (
            <PortfolioTravelItem key={i} item={item} />
          ))}
        </div>
      </Collapsable>
    </div>
  );
};
